import ReactDOM from 'react-dom/client';
import React from 'react';
import { v2Component } from '../../index';
import { TenantContext } from '../../context/tenant-context';
import { CycleBillingDurationConfig } from './cycle-billing-duration-config';

export function initCycleBillingDurationConfig(element?: HTMLElement) {
  const elements = element !== undefined ? [element] : document.getElementsByName('cycle-billing-duration-config');

  elements.forEach((element) => {
    if (element.getAttribute('initialized') !== 'true') {
      element.setAttribute('initialized', 'true');
      const root = ReactDOM.createRoot(element);
      const bootstrap = () => {
        const { tenant, contextPath, ...dataset } = Object.assign({}, element.dataset) as any;
        const props = {
          ...dataset,
        };

        root.render(
          v2Component(
            <TenantContext.Provider value={{ tenant, contextPath, spaMode: false }}>
              <CycleBillingDurationConfig {...props} />
            </TenantContext.Provider>,
          ),
        );
      };
      bootstrap();
    }
  });
}
